import React from 'react';
import dayjs from 'dayjs';

import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';
import XIcon from '@/components/Icons/icons/XIcon';

import CustomDatePickerInput from '../../../ContractsBox/NewContractModal/CustomDatePickerInput';

interface Props {
  selectedEndDate: string | null;
  setSelectedEndDate: (selectedEndDate: string | null) => void;
  frequency: number;
  label?: string;
  className?: string;
  placeholder?: string;
  inputClassName?: string;
}

const EndDatePicker: React.FC<Props> = ({
  selectedEndDate,
  setSelectedEndDate,
  frequency,
  label = 'Automation Lasts Until',
  className = '',
  placeholder = 'Forever',
  inputClassName = '',
}) => {
  return (
    <div className={className}>
      <CustomDatePickerInput
        label={label}
        required
        date={selectedEndDate}
        setDate={(value: string) => setSelectedEndDate(value)}
        popoverPosition={{
          anchorOrigin: { vertical: 'center', horizontal: 'right' },
          transformOrigin: { vertical: 'center', horizontal: 'left' },
        }}
        dateFormat="DD MMMM, YYYY"
        placeholder={placeholder}
        maxDate={null}
        minDate={dayjs(new Date()).add(frequency, 'days').toDate()}
        disabled={false}
        inputWrapperClass="hover-grey-border"
        inputClassName={inputClassName}
        right={
          selectedEndDate ? (
            <CustomTooltip title="Remove">
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEndDate('');
                }}>
                <XIcon width={24} height={24} />
              </div>
            </CustomTooltip>
          ) : (
            <></>
          )
        }
      />
    </div>
  );
};

export default EndDatePicker;
